import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  getGallery: ["payload"],
  getGallerySuccess: ["payload", "isLoading"],
  getGalleryFail: ["isLoading", "error"],

  getGalleryFolder: ["id"],
  getGalleryFolderSuccess: ["payload", "isLoading"],
  getGalleryFolderFail: ["isLoading", "error"],

  getGalleryPhotos: ["id"],
  getGalleryPhotosSuccess: ["payload", "isLoadingPhotos"],
  getGalleryPhotosFail: ["isLoadingPhotos"],
});

const INITIAL_STATE = {
  galleryList: [],
  galleryDetails: { pagination: { next_page: 1 } },
  isLoadingGallery: false,
  isLoadingPhotos: false,
  hasMorePhotos: true,
  error: [],
  hasMoreGallery: true,
  pageGallery: 1,
};

const getGallery = (state) => ({
  ...state,
  isLoadingGallery: true,
});
const getGallerySuccess = (state, payload) => ({
  ...state,
  ...payload,
  isLoadingGallery: false,
});
const getGalleryFail = (state) => ({
  ...state,
  isLoadingGallery: false,
});

const getGalleryFolder = (id) => ({ ...id, isLoadingGallery: true });
const getGalleryFolderSuccess = (state, payload) => ({
  ...state,
  ...payload,
  isLoadingGallery: false,
});
const getGalleryFolderFail = (state) => ({
  ...state,
  isLoadingGallery: false,
});

const getGalleryPhotos = (id) => ({
  ...id,
  isLoadingPhotos: true,
});
const getGalleryPhotosSuccess = (state, { pagination, contents }) => ({
  ...state,
  galleryDetails: {
    pagination,
    gallery_contents: contents,
  },
  isLoadingPhotos: false,
});
const getGalleryPhotosFail = (state) => ({
  ...state,
  isLoadingPhotos: false,
});

export default createReducer(INITIAL_STATE, {
  [Types.GET_GALLERY]: getGallery,
  [Types.GET_GALLERY_SUCCESS]: getGallerySuccess,
  [Types.GET_GALLERY_FAIL]: getGalleryFail,

  [Types.GET_GALLERY_FOLDER]: getGalleryFolder,
  [Types.GET_GALLERY_FOLDER_SUCCESS]: getGalleryFolderSuccess,
  [Types.GET_GALLERY_FOLDER_FAIL]: getGalleryFolderFail,

  [Types.GET_GALLERY_PHOTOS]: getGalleryPhotos,
  [Types.GET_GALLERY_PHOTOS_SUCCESS]: getGalleryPhotosSuccess,
  [Types.GET_GALLERY_PHOTOS_FAIL]: getGalleryPhotosFail,
});
